<template>
  <div class="loading">Авторизуємось…</div>
</template>

<script>
import axios from 'axios'
import appconfig from "../../app/config";
import {mapActions} from "vuex";
export default {
  name: 'LoginByToken',
  methods: {
    ...mapActions({
      signIn: 'auth/login'
    }),
  },
  async created() {
    const token = this.$route.query.token
    if (!token) {
      this.$router.push('/login')
      return
    }

    try {
      const response = await axios.post(appconfig.Point +'api/constructor/v1/login-by-token', { token })

      let data = response.data;
      data.user['defaultStock'] = data.defaultStock

      this.signIn(data)

    } catch (error) {
      this.$router.push('/login')
    }
  }
}
</script>
